import styled from "@emotion/styled";
import { WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";
import Colors from "styles/colors";
export const StyledSideBySideBoardViewsComponentTabsMobileComponent = styled.div`
  .mobile-tabs-component {
    .mobile-tabs-navigation {
      gap: 16px;
      .tab-nav-board-views-button {
        &:after {
          content: "";
          height: 2px;
          width: 100%;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          background-color: transparent;
          display: flex;
          transition: background-color 0.15s ease-in-out;
        }
      }
      .tab-nav-board-views-button.selected {
        &:after {
          background-color: ${Colors[WORK_OS_IRIS_COLOR_NAME]};
        }
      }
      .title-and-icon-wrapper {
        padding: 0 4px;
        .icon-wrapper {
          margin-top: 4px;
          margin-right: 4px;
          align-items: center;

          .picture-icon-wrapper.picture-component {
            width: 18px;
            height: 18px;
            margin-bottom: 0;
          }
        }
      }
    }
  }
`;
